import DropFileZone from './DropFileZone';

export default DropFileZone;
